module.exports = __webpack_public_path__ + "static/media/Email.64b13099.svg";